import { NextPage, NextPageContext } from 'next'
import {
  useEventQuery,
  useBaseCollectiveQuery,
  useResolveSubdomainQuery
} from 'graphql/generated'
import React from 'react'
import Head from 'next/head'
import SignupForm from 'components/Signup/SignupForm'
import { useSubdomain } from 'lib/subdomainUtils'

interface ISignupPage {
  communityId?: string
  eventId?: string
  onboarding?: Maybe<KVMap>
  collectiveId?: string
  signature?: string
  ephemeralCryptoAuthId?: string
  address?: string
}

const SignupPage: NextPage<ISignupPage> = ({
  eventId,
  onboarding,
  address,
  signature,
  ephemeralCryptoAuthId,
  collectiveId
}) => {
  const { data: { event } = {} } = useEventQuery({
    variables: { id: eventId! },
    skip: !eventId
  })

  const subdomain = useSubdomain()
  const { data: { resolveSubdomain } = {} } = useResolveSubdomainQuery({
    variables: { slug: subdomain! },
    skip: !subdomain
  })
  const combinedCollectiveId =
    collectiveId ||
    (resolveSubdomain?.__typename === 'Collective' ? resolveSubdomain.id : null)
  const { data: { collective } = {} } = useBaseCollectiveQuery({
    variables: {
      collectiveId: combinedCollectiveId!
    },
    skip: !combinedCollectiveId
  })

  const wallet =
    !!collective && !!address && !!signature && !!ephemeralCryptoAuthId
      ? {
          address,
          signature,
          ephemeralCryptoAuthId
        }
      : undefined

  return (
    <>
      <Head>
        <title>Upstream | Sign Up</title>
      </Head>

      <SignupForm
        event={event || undefined}
        onboarding={onboarding}
        collective={collective}
        wallet={wallet}
      />
    </>
  )
}

SignupPage.getInitialProps = async (ctx: NextPageContext) => {
  const communityId: string = ctx.query.communityId as string
  const eventId: string = ctx.query.eventId as string

  const collectiveId: string = ctx.query.collectiveId as string
  const signature: string = ctx.query.signature as string
  const ephemeralCryptoAuthId: string = ctx.query
    .ephemeralCryptoAuthId as string
  const address: string = ctx.query.address as string

  let onboarding = {}

  try {
    if (ctx.query.onboarding) {
      onboarding = JSON.parse(ctx.query.onboarding as string)
    }
  } catch (err) {
    // ignore
  }

  return {
    communityId,
    eventId,
    onboarding,
    collectiveId,
    signature,
    ephemeralCryptoAuthId,
    address
  }
}

export default SignupPage
